<div class="detail-page-card">
    @if (!config.hideHeader) {
        <div class="detail-page-card-title">{{ config.name }}</div>
    }
    <div class="detail-page-card-actions">
        @if (
            (config.allowAdd && !config.hideAddButton) ||
            (config.allowDelete && !config.hideDeleteButton)
        ) {
            <div>
                @if (config.allowAdd && !config.hideAddButton) {
                    <button
                        [attr.data-uiid]="config.uiidAdd"
                        class="btn btn-raised"
                        (click)="addRow()"
                    >
                        <i class="fas fa-plus-circle"></i>
                        <span>{{ "genericListManager.add" | transloco }}</span>
                    </button>
                }
                @if (config.allowDelete && !config.hideDeleteButton) {
                    <button
                        [attr.data-uiid]="config.uiidDelete"
                        class="btn btn-raised red"
                        (click)="deleteRow(activeRow)"
                        [disabled]="!activeRow"
                    >
                        <i class="fas fa-trash"></i>
                        <span>{{ "genericListManager.delete" | transloco }}</span>
                    </button>
                }
            </div>
        }
        @if (config.showToolbarSearch) {
            <div>
                <input
                    type="text"
                    class="form-control"
                    [placeholder]="'genericListManager.searchPlaceholder' | transloco"
                    (debounce-input-event)="config.onSearch($event)"
                    inputTooltip
                />
            </div>
        }
        @if (config.allowLink && !config.hideLinkButton) {
            <div>
                <button class="btn btn-raised blue" (click)="openLinkModal()">
                    <i class="fas fa-link"></i>
                    <span>{{ "genericListManager.link" | transloco }}</span>
                </button>
            </div>
        }
        @if (config.dataMethod && !config.hideRefreshButton) {
            <div>
                @let reloadConfirmTitle = "genericListManager.reloadConfirmTitle" | transloco;
                @let reloadConfirmBody =
                    "genericListManager.reloadConfirmBody" | transloco: { name: config.name };
                <button
                    class="btn btn-raised green"
                    (click)="loadPage(reloadConfirmTitle, reloadConfirmBody)"
                >
                    <i class="fas fa-sync"></i>
                    <span>{{ "genericListManager.reload" | transloco }}</span>
                </button>
            </div>
        }
    </div>

    @if (ready) {
        @if (!tableData || tableData.length === 0) {
            <div class="detail-page-card-body padded">
                @if (config.emptyMessage) {
                    <small>{{ config.emptyMessage }}</small>
                } @else {
                    <small>{{
                        "genericListManager.emptyList"
                            | transloco: { name: (config.name | lowercase) }
                    }}</small>
                    @if (config.allowAdd) {
                        <small
                            [innerHTML]="'genericListManager.clickAddHint' | transloco"
                        ></small>
                    }
                }
            </div>
        }
    } @else {
        <div class="detail-page-card-body padded cerrix-control-sm">
            <div class="fancy-loader submodule"></div>
        </div>
    }

    @if (scopedTableData && scopedTableData.length > 0) {
        <div class="detail-page-card-body overflow-auto">
            <table class="table-cerrix rounded striped bordered-columns reset table-hoverable">
                <thead>
                    <tr>
                        <th class="small-header"></th>
                        @for (field of config.fields; track field) {
                            @if (!field.hideInOverview) {
                                <th class="text-center">
                                    {{ field.prettyName ? field.prettyName : field.fieldName }}
                                </th>
                            }
                        }
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    @for (outerData of scopedTableData; track outerData) {
                        <tr
                            class="row-hover"
                            [ngClass]="{
                                highlighted: activeRow && activeRow[idProp] === outerData[idProp],
                            }"
                            (click)="triggerClick(outerData)"
                        >
                            <td
                                class="text-center small-header"
                                (click)="
                                    getLinkedIds(outerData);
                                    outerData.showEditor = !outerData.showEditor
                                "
                            >
                                <div>
                                    <span>
                                        <i
                                            class="far"
                                            [class.fa-minus-square]="outerData.showEditor"
                                            [class.fa-plus-square]="!outerData.showEditor"
                                        ></i>
                                    </span>
                                </div>
                            </td>
                            @for (field of config.fields; track field) {
                                @if (!field.hideInOverview) {
                                    <td class="text-truncate text-center">
                                        <workspace-cell
                                            [configs]="config.rendererConfig"
                                            [row]="outerData"
                                            [header]="field.fieldName"
                                        >
                                        </workspace-cell>
                                    </td>
                                }
                            }
                            <td class="text-center">
                                @for (action of config.overviewRowActions; track action) {
                                    <span>
                                        <i
                                            class="{{ action.icon }}"
                                            matTooltip="{{ action.tooltip }}"
                                            (click)="action.clickEvent(outerData)"
                                        >
                                        </i>
                                    </span>
                                }
                            </td>
                        </tr>
                        @if (outerData.showEditor) {
                            <tr class="inner-table">
                                <td [colSpan]="colSpan">
                                    @if (innerConfig) {
                                        <generic-list-manager [config]="innerConfig">
                                        </generic-list-manager>
                                    }
                                </td>
                            </tr>
                        }
                    }
                </tbody>
            </table>
            @if (scopedToggleAllowed) {
                <div class="custom-pagination" (click)="toggleScopedTableData()">
                    {{
                        (scopedTableExpanded
                            ? "genericListManager.viewLast"
                            : "genericListManager.viewAll"
                        )
                            | transloco
                                : {
                                      count: scopedTableExpanded
                                          ? config.limitViewTo
                                          : config._visibleRowCount
                                  }
                    }}
                </div>
            }
        </div>
    }
</div>
